import type { InsuranceScenarioKey as InsuranceScenarioKeyPrisma } from '@/backend/src/services/other/prisma.js'
import type { InsuranceCustomerType } from '@/general/src/insuranceCustomerType/shared.js'
import { getInsuranceProviderTitle, type InsuranceProvider } from '@/general/src/insuranceProvider/shared.js'
import { personalKaskoByOsagoAlfaGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoByOsagoAlfa/shared.js'
import { personalKaskoByOsagoIngosGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoByOsagoIngos/shared.js'
import { personalKaskoByOsagoRenesGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoByOsagoRenes/shared.js'
import { personalKaskoByOsagoRosgosGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoByOsagoRosgos/shared.js'
import { personalKaskoByOsagoVskGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoByOsagoVsk/shared.js'
import { personalKaskoFromScratchAlfaGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoFromScratchAlfa/shared.js'
import { personalKaskoFromScratchIngosGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoFromScratchIngos/shared.js'
import { personalKaskoFromScratchRenesGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoFromScratchRenes/shared.js'
import { personalKaskoFromScratchRosgosGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoFromScratchRosgos/shared.js'
import { personalKaskoFromScratchVskGeneral } from '@/general/src/insuranceScenario/personalKasko/personalKaskoFromScratchVsk/shared.js'
import { personalOsagoFromScratchAlfaGeneral } from '@/general/src/insuranceScenario/personalOsago/personalOsagoFromScratchAlfa/shared.js'
import { personalOsagoFromScratchIngosGeneral } from '@/general/src/insuranceScenario/personalOsago/personalOsagoFromScratchIngos/shared.js'
import { personalOsagoFromScratchRenesGeneral } from '@/general/src/insuranceScenario/personalOsago/personalOsagoFromScratchRenes/shared.js'
import { personalOsagoFromScratchRosgosGeneral } from '@/general/src/insuranceScenario/personalOsago/personalOsagoFromScratchRosgos/shared.js'
import { personalOsagoFromScratchVskGeneral } from '@/general/src/insuranceScenario/personalOsago/personalOsagoFromScratchVsk/shared.js'

import { zPersonalOsagoInsuranceScenarioResult } from '@/general/src/insuranceScenario/personalOsago/shared.js'
import type { InsuranceType } from '@/general/src/insuranceType/shared.js'
import { checkEnumEq } from '@/general/src/other/checkEnumEq.js'
import { getConstKeys } from '@/general/src/other/getConstKeys.js'
import { z } from 'zod'

export const insuranceScenariosGenerals = [
  personalOsagoFromScratchAlfaGeneral,
  personalOsagoFromScratchIngosGeneral,
  personalOsagoFromScratchRenesGeneral,
  personalOsagoFromScratchRosgosGeneral,
  personalOsagoFromScratchVskGeneral,
  personalKaskoFromScratchAlfaGeneral,
  personalKaskoFromScratchIngosGeneral,
  personalKaskoFromScratchRenesGeneral,
  personalKaskoFromScratchRosgosGeneral,
  personalKaskoFromScratchVskGeneral,
  personalKaskoByOsagoAlfaGeneral,
  personalKaskoByOsagoIngosGeneral,
  personalKaskoByOsagoRenesGeneral,
  personalKaskoByOsagoRosgosGeneral,
  personalKaskoByOsagoVskGeneral,
]

export const insuranceScenarioStatusMap = {
  inactive: 'Выключен',
  initializing: 'Инициализация',
  running: 'Запущен',
  finished: 'Завершён',
  failed: 'Ошибка',
  cancelled: 'Отменён',
} as const
export const insuranceScenarioStatuses = getConstKeys(insuranceScenarioStatusMap)
export const zInsuranceScenarioStatus = z.enum(insuranceScenarioStatuses)
export type InsuranceScenarioStatus = (typeof insuranceScenarioStatuses)[number]
export const getInsuranceScenarioStatusTitle = ({ status }: { status: InsuranceScenarioStatus }) => {
  return insuranceScenarioStatusMap[status]
}

export const personalOsagoFromScratchInsuranceScenariosKeys = [
  'personalOsagoFromScratchAlfa',
  'personalOsagoFromScratchIngos',
  'personalOsagoFromScratchRenes',
  'personalOsagoFromScratchRosgos',
  'personalOsagoFromScratchVsk',
] as const
export const zPersonalOsagoFromScratchInsuranceScenarioKey = z.enum(personalOsagoFromScratchInsuranceScenariosKeys)
export type PersonalOsagoFromScratchInsuranceScenarioKey =
  (typeof personalOsagoFromScratchInsuranceScenariosKeys)[number]

export const personalOsagoInsuranceScenariosKeys = [...personalOsagoFromScratchInsuranceScenariosKeys] as const
export const zPersonalOsagoInsuranceScenarioKey = z.enum(personalOsagoInsuranceScenariosKeys)
export type PersonalOsagoInsuranceScenarioKey = (typeof personalOsagoInsuranceScenariosKeys)[number]

export const personalKaskoFromScratchInsuranceScenariosKeys = [
  'personalKaskoFromScratchAlfa',
  'personalKaskoFromScratchIngos',
  'personalKaskoFromScratchRenes',
  'personalKaskoFromScratchRosgos',
  'personalKaskoFromScratchVsk',
] as const
export const zPersonalKaskoFromScratchInsuranceScenarioKey = z.enum(personalKaskoFromScratchInsuranceScenariosKeys)
export type PersonalKaskoFromScratchInsuranceScenarioKey =
  (typeof personalKaskoFromScratchInsuranceScenariosKeys)[number]
export const filterPersonalKaskoFromScratchInsuranceScenarioKeys = ({
  insuranceScenariosKeys,
}: {
  insuranceScenariosKeys: InsuranceScenarioKey[]
}) => {
  return insuranceScenariosKeys.filter((insuranceScenarioKey) =>
    personalKaskoFromScratchInsuranceScenariosKeys.includes(
      insuranceScenarioKey as PersonalKaskoFromScratchInsuranceScenarioKey
    )
  )
}

export const personalKaskoByOsagoInsuranceScenariosKeys = [
  'personalKaskoByOsagoAlfa',
  'personalKaskoByOsagoIngos',
  'personalKaskoByOsagoRenes',
  'personalKaskoByOsagoRosgos',
  'personalKaskoByOsagoVsk',
] as const
export const zPersonalKaskoByOsagoInsuranceScenarioKey = z.enum(personalKaskoByOsagoInsuranceScenariosKeys)
export type PersonalKaskoByOsagoInsuranceScenarioKey = (typeof personalKaskoByOsagoInsuranceScenariosKeys)[number]
export const filterPersonalKaskoByOsagoInsuranceScenarioKeys = ({
  insuranceScenariosKeys,
}: {
  insuranceScenariosKeys: InsuranceScenarioKey[]
}) => {
  return insuranceScenariosKeys.filter((insuranceScenarioKey) =>
    personalKaskoByOsagoInsuranceScenariosKeys.includes(
      insuranceScenarioKey as PersonalKaskoByOsagoInsuranceScenarioKey
    )
  )
}

export const personalKaskoInsuranceScenariosKeys = [
  ...personalKaskoFromScratchInsuranceScenariosKeys,
  ...personalKaskoByOsagoInsuranceScenariosKeys,
] as const
export const zPersonalKaskoInsuranceScenarioKey = z.enum(personalKaskoInsuranceScenariosKeys)
export type PersonalKaskoInsuranceScenarioKey = (typeof personalKaskoInsuranceScenariosKeys)[number]

export const insuranceScenariosKeys = [
  ...personalOsagoInsuranceScenariosKeys,
  ...personalKaskoInsuranceScenariosKeys,
] as const
export type InsuranceScenarioKey = (typeof insuranceScenariosKeys)[number]
checkEnumEq<InsuranceScenarioKey, InsuranceScenarioKeyPrisma, true>()
export const zInsuranceScenarioKey = z.enum(insuranceScenariosKeys)
export type InsuranceScenarioGeneral<TInsuranceType extends InsuranceType = InsuranceType> = {
  title: string
  titleShort: string
  insuranceProvider: InsuranceProvider
  insuranceType: TInsuranceType
  insuranceCustomerType: InsuranceCustomerType
  insuranceScenarioKey: InsuranceScenarioKey
}

export const getInsuranceScenarioKeysOptions = ({ insuranceType }: { insuranceType: InsuranceType }) => {
  return insuranceScenariosGenerals
    .filter((insuranceScenarioGeneral) => insuranceScenarioGeneral.insuranceType === insuranceType)
    .map((insuranceScenarioGeneral) => ({
      value: insuranceScenarioGeneral.insuranceScenarioKey,
      label: insuranceScenarioGeneral.title,
    }))
}

export const getInsuranceScenarioKeysOptionsWithInsuranceProviderLabel = ({
  insuranceType,
}: {
  insuranceType: InsuranceType
}) => {
  return insuranceScenariosGenerals
    .filter((insuranceScenarioGeneral) => insuranceScenarioGeneral.insuranceType === insuranceType)
    .map((insuranceScenarioGeneral) => ({
      value: insuranceScenarioGeneral.insuranceScenarioKey,
      label: getInsuranceProviderTitle(insuranceScenarioGeneral.insuranceProvider),
    }))
}

export const getInsuranceScenarioGeneral = ({
  insuranceScenarioKey,
}: {
  insuranceScenarioKey: InsuranceScenarioKey
}): InsuranceScenarioGeneral => {
  return insuranceScenariosGenerals.find(
    (insuranceScenarioGeneral) => insuranceScenarioGeneral.insuranceScenarioKey === insuranceScenarioKey
  ) as InsuranceScenarioGeneral
}

export const getInsuranceScenarioGeneralOrNull = ({
  insuranceScenarioKey,
}: {
  insuranceScenarioKey: string
}): InsuranceScenarioGeneral | null => {
  return insuranceScenariosGenerals.find(
    (insuranceScenarioGeneral) => insuranceScenarioGeneral.insuranceScenarioKey === insuranceScenarioKey
  ) as InsuranceScenarioGeneral | null
}

export const getInsuranceScenarioTitle = ({ insuranceScenarioKey }: { insuranceScenarioKey: InsuranceScenarioKey }) => {
  return getInsuranceScenarioGeneral({ insuranceScenarioKey }).title
}

export const getInsuranceScenarioTitleOrUnknown = ({ insuranceScenarioKey }: { insuranceScenarioKey: string }) => {
  return getInsuranceScenarioGeneralOrNull({ insuranceScenarioKey })?.title || 'Неизвестный сценарий'
}

export const getInsuranceScenarioTitleShort = ({
  insuranceScenarioKey,
}: {
  insuranceScenarioKey: InsuranceScenarioKey
}) => {
  return getInsuranceScenarioGeneral({ insuranceScenarioKey }).titleShort
}

export const getInsuranceScenarioTitleShortOrUnknown = ({ insuranceScenarioKey }: { insuranceScenarioKey: string }) => {
  return getInsuranceScenarioGeneralOrNull({ insuranceScenarioKey })?.titleShort || 'Неизвестный сценарий'
}

export const getInsuranceProviderTitleByInsuranceScenarioKey = ({
  insuranceScenarioKey,
}: {
  insuranceScenarioKey: InsuranceScenarioKey
}) => {
  const insuranceProvider = getInsuranceScenarioGeneral({ insuranceScenarioKey }).insuranceProvider
  return getInsuranceProviderTitle(insuranceProvider)
}

export const isInsuraceScenarioKeySuitableToInsuranceType = ({
  insuranceScenarioKey,
  insuranceType,
}: {
  insuranceScenarioKey: InsuranceScenarioKey
  insuranceType: InsuranceType
}) => {
  const insuranceScenarioGeneral = getInsuranceScenarioGeneral({ insuranceScenarioKey })
  return insuranceScenarioGeneral.insuranceType === insuranceType
}

export const isInsuraceScenarioKeysSuitableToInsuranceType = ({
  insuranceScenariosKeys,
  insuranceType,
}: {
  insuranceScenariosKeys: InsuranceScenarioKey[]
  insuranceType: InsuranceType
}) => {
  return insuranceScenariosKeys.every((insuranceScenarioKey) =>
    isInsuraceScenarioKeySuitableToInsuranceType({ insuranceScenarioKey, insuranceType })
  )
}

export const filterSuitableInsuranceScenariosKeysByInsuranceType = ({
  insuranceType,
  insuranceScenarioKeys,
}: {
  insuranceType: InsuranceType
  insuranceScenarioKeys: InsuranceScenarioKey[]
}) => {
  return insuranceScenarioKeys.filter((insuranceScenarioKey) =>
    isInsuraceScenarioKeySuitableToInsuranceType({ insuranceScenarioKey, insuranceType })
  )
}

export const getInsuranceTypeByInsuranceScenarioKey = ({
  insuranceScenarioKey,
}: {
  insuranceScenarioKey: InsuranceScenarioKey
}) => {
  return getInsuranceScenarioGeneral({ insuranceScenarioKey }).insuranceType
}

export const getInsuranceProviderByInsuranceScenarioKey = ({
  insuranceScenarioKey,
}: {
  insuranceScenarioKey: InsuranceScenarioKey
}) => {
  return getInsuranceScenarioGeneral({ insuranceScenarioKey }).insuranceProvider
}

export const getInsuranceProvidersByInsuranceScenariosKeys = ({
  insuranceScenariosKeys,
}: {
  insuranceScenariosKeys: InsuranceScenarioKey[]
}) => {
  return [
    ...new Set(
      insuranceScenariosKeys.map((insuranceScenarioKey) =>
        getInsuranceProviderByInsuranceScenarioKey({ insuranceScenarioKey })
      )
    ),
  ]
}

export const getInsuranceScenarioResultZSchema = ({ insuranceType }: { insuranceType: InsuranceType }) => {
  return {
    personalOsago: zPersonalOsagoInsuranceScenarioResult,
    personalKasko: zPersonalOsagoInsuranceScenarioResult,
  }[insuranceType]
}
